import React from 'react';
import PropTypes from 'prop-types';
import { Popover, Tag, Typography } from 'antd';

const { Text } = Typography;

/**
 * Celda "Validación" de la tabla de recibos (C4): resultado de la validación previa del
 * servidor (solo lectura, sin timbrar). Las reglas viven en SAC; aquí solo se presentan.
 * Los mensajes del servidor no llevan datos personales.
 */
const ValidacionReciboTimbrado = ({ validacion, cargando, error }) => {
  if (!validacion) {
    if (cargando) return <Text type="secondary">Validando...</Text>;
    if (error) return <Text type="secondary">No validado</Text>;
    return <Text type="secondary">—</Text>;
  }
  if (validacion.estado === 'no_aplica') return <Text type="secondary">—</Text>;
  if (validacion.timbrable) return <Tag color="green">OK</Tag>;

  const { problemas } = validacion;
  const contenido = (
    <ul style={{ maxWidth: 420, paddingLeft: 16, margin: 0 }}>
      {problemas.map((problema, indice) => (
        // eslint-disable-next-line react/no-array-index-key
        <li key={`${problema.codigo}-${indice}`}>
          <Text strong>{problema.donde}</Text>
          {': '}
          {problema.mensaje}
          <br />
          <Text type="secondary" style={{ fontSize: '0.8em' }}>
            {problema.codigo}
            {problema.elemento ? ` · ${problema.elemento}` : ''}
          </Text>
        </li>
      ))}
    </ul>
  );
  const etiqueta = problemas.length === 1 ? '1 Problema' : `${problemas.length} Problemas`;
  return (
    <Popover title="Qué Corregir Antes de Timbrar" content={contenido} trigger={['hover', 'click']}>
      <Tag color="red" style={{ cursor: 'pointer' }} onClick={(e) => e.stopPropagation()}>
        {etiqueta}
      </Tag>
    </Popover>
  );
};

ValidacionReciboTimbrado.propTypes = {
  validacion: PropTypes.shape({
    estado: PropTypes.string,
    timbrable: PropTypes.bool,
    problemas: PropTypes.arrayOf(PropTypes.shape({
      codigo: PropTypes.string,
      elemento: PropTypes.string,
      donde: PropTypes.string,
      mensaje: PropTypes.string,
    })),
  }),
  cargando: PropTypes.bool,
  error: PropTypes.bool,
};

ValidacionReciboTimbrado.defaultProps = {
  validacion: null,
  cargando: false,
  error: false,
};

export default ValidacionReciboTimbrado;
